// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"videoPlay-module--video-container--1VwkB","play":"videoPlay-module--play--2mjld"};